import { addStyles } from '../theme';
export function createTransformKeyFrame(name: string, transformFrom: string, transformTo: string) {
	addStyles({
		[`@keyframes ${name}`]: { from: { transform: transformFrom }, to: { transform: transformTo } },
	});
}
